import React, { useState, useEffect } from "react";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { Link } from "react-router-dom";

interface MonthData {
    month: string;
    carriedForward: number;
    received: number;
    resolved: string;
    pending: number;
}

function getPreviousMonthWithYear(baseDate: Date = new Date()): string {
    const date = new Date(baseDate);
    date.setMonth(date.getMonth() - 1);

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${month} ${year}`;
}

const InvestorCharter: React.FC = () => {
    const [selectedPage, setSelectedPage] = useState<string>("annexureA");
    const [months, setMonths] = useState<MonthData[]>([]);
    const [data, setData] = useState<any[]>([]);


    useEffect(() => {
        const getLast12Months = () => {
            const monthsArr: MonthData[] = [];
            const currentDate = new Date();

            // Get last 12 months excluding the current month
            for (let i = 1; i <= 12; i++) {
                const date = new Date();
                date.setMonth(currentDate.getMonth() - i); // go back by i months
                const month = date.toLocaleString("default", { month: "short" }) + "-" + (date.getFullYear() % 100);
                monthsArr.push({
                    month: month,
                    carriedForward: 0,
                    received: 0,
                    resolved: "NA",
                    pending: 0
                });
            }

            setMonths(monthsArr);
        };
        const getYearlyData = () => {
            const currentYear = new Date().getFullYear(); // Get current year
            const years: { year: string; carriedForward: string | number; received: number; resolved: string; pending: number }[] = [];

            // Create year ranges dynamically for the last 3 years and the current year
            for (let i = 2021; i <= currentYear - 1; i++) {
                const yearRange = `${i}-${i + 1}`;
                years.push({
                    year: yearRange,
                    carriedForward: i === 2021 ? "-" : 0, // Set carriedForward as '-' for the first year
                    received: 0,
                    resolved: "NA",
                    pending: 0
                });
            }

            setData(years);
        };
        getYearlyData();
        getLast12Months();
    }, []);

    const complaintData = {
        beginning: 0,
        received: 0,
        resolved: 0,
        pending: 0,
        lastUpdated: getPreviousMonthWithYear(),
    };
    // const complaintDataList = {
    //     monthly: {
    //         carriedForward: 0,
    //         received: 0,
    //         resolved: "NA",
    //         pending: 0
    //     },
    //     annual: {
    //         carriedForward: 0,
    //         received: 0,
    //         resolved: "NA",
    //         pending: 0
    //     }
    // };

    // Function to render content based on selectedPage
    const renderContent = () => {
        switch (selectedPage) {
            case "annexureA":
                return <section className="text-white min-h-screen">
                    <div className="max-w-7xl">
                        {/* Vision and Mission */}
                        <div className="mb-6 text-justify">
                            <h2 className="text-lg font-semibold mb-6">A. Vision and Mission Statements</h2>
                            <h3 className="font-bold text-md text-white mt-4">Vision</h3>
                            <p className="mt-2 text-md">Invest with knowledge & safety.</p>

                            <h3 className="font-bold text-md text-white mt-4">Mission</h3>
                            <p className="mt-2 text-md">
                                Every investor should be able to invest in right investment products based on their needs, manage and monitor them to meet their goals, access reports and enjoy financial wellness.</p>
                        </div>

                        {/* Business Transacted */}
                        <div className="mb-6 text-justify">
                            <h2 className="text-lg font-semibold mb-6">B. Details of business transacted by the Investment Adviser (Nuqi Wealth) with respect to

                                the investors</h2>
                            <ul className="list-disc list-inside mt-2 text-md space-y-2">
                                <li>Nuqi Wealth to enter into an agreement with the client providing all details including fee

                                    details, aspect of Conflict of interest disclosure and maintaining

                                    confidentiality of information.</li>
                                <li>To do a proper and unbiased risk – profiling and suitability assessment of

                                    the client.</li>
                                <li>To obtain registration with Know Your Client Registration Agency (KRA) and

                                    Central Know Your Customer Registry (CKYC).</li>
                                <li>To conduct audit annually.</li>
                                <li>To disclose the status of complaints in its website.</li>
                                <li>To disclose the name, proprietor name, type of registration, registration number, validity, complete address with telephone numbers and associated SEBI regional/local Office details in its website.</li>
                                <li>To employ only qualified and certified employees.</li>
                                <li>To deal with clients only from official number</li>
                                <li>To maintain records of interactions, with all clients including prospective clients (prior to onboarding), where any conversation related to advice has taken place.</li>
                                <li>To ensure that all advertisements are in adherence to the provisions of the Advertisement Code for Investment Advisers.</li>
                                <li>Not to discriminate in terms of services provided, among clients opting for same/similar products/services offered by investment adviser.</li>
                            </ul>
                        </div>

                        {/* Services Provided */}
                        <div className="mb-6 text-justify">
                            <h2 className="text-lg font-semibold mb-6">C. Details of services provided to investors (No Indicative Timelines)</h2>
                            <h3 className="font-bold text-md text-white mt-4">Onboarding of Clients</h3>
                            <ul className="list-disc list-inside mt-2 text-md space-y-2">
                                <li>Sharing of agreement copy.</li>
                                <li>Completing KYC of clients.</li>
                            </ul>

                            <h3 className="font-bold text-md text-white mt-4">Disclosure to Clients</h3>
                            <ul className="list-disc list-inside mt-2 text-md space-y-2">
                                <li>To provide full disclosure about Nuqi Wealth’s business, affiliations, compensation in the agreement</li>
                                <li>To not access client’s accounts or holdings for offering advice.</li>
                                <li>To disclose the risk profile to the client.</li>
                                <li>Investment advice based on risk profiling and suitability.</li>
                                <li>To disclose any conflict of interest of the investment advisory activities with any other activities of the investment adviser.</li>
                                <li>To disclose the extent of use of Artificial Intelligence tools in providing investment advisory services.</li>
                            </ul>
                            <h3 className="font-bold text-md text-white mt-4">To provide investment advice to the client based on the risk-profiling of the clients and suitability of the client.</h3>
                            <h3 className="font-bold text-md text-white mt-4">To treat all advisory clients with honesty and integrity.</h3>
                            <h3 className="font-bold text-md text-white mt-4">To make adequate disclosure to the investor of all material facts such as risks, obligations, costs, etc. relating to the products or securities advised by the adviser.</h3>
                            <h3 className="font-bold text-md text-white mt-4">To provide clear guidance and adequate caution notice to clients when providing investment advice for dealing in complex and high-risk financial products/services.</h3>
                            <h3 className="font-bold text-md text-white mt-4">To ensure confidentiality of information shared by clients unless such information is required to be provided in furtherance of discharging legal obligations or a client has provided specific consent to share such information.</h3>
                            <h3 className="font-bold text-md text-white mt-4">To disclose the timelines for the various services provided by the investment adviser to clients and ensure adherence to the said timelines.</h3>
                        </div>

                        {/* Grievance Redressal */}
                        <div className="mb-6 text-justify">
                            <h2 className="text-lg font-semibold mb-6">D. Details of grievance redressal mechanism and how to access it.</h2>
                            <ol className="list-decimal list-inside mt-2 text-md space-y-2">
                                <li>In case of any grievance / complaint, an investor should approach Nuqi Wealth and shall ensure that the grievance is resolved within 30 days.</li>
                                <li>If the investor’s complaint is not redressed satisfactorily, one may lodge a complaint with SEBI on SEBI’s 'SCORES' portal which is a centralized web-based complaints redressal system. SEBI takes up the complaints registered via SCORES with the concerned intermediary for timely redressal. SCORES facilitates tracking the status of the complaint.</li>
                                <li>With regard to physical complaints, investors may send their complaints to: Office of Investor Assistance and Education, Securities and Exchange Board of India, SEBI Bhavan, Plot No. C4-A, ‘G’ Block, Bandra-Kurla Complex, Bandra (E), Mumbai - 400 051.
                                </li>
                            </ol>
                        </div>

                        {/*Rights of investors */}
                        <div className="mb-6 text-justify">
                            <h2 className="text-lg font-semibold mb-6">E. Rights of investors</h2>

                            <ul className="list-[upper-roman] list-inside mt-2 text-md space-y-2 text-justify">
                                <li>Right to Privacy and Confidentiality</li>
                                <li>Right to Transparent Practices</li>
                                <li>Right to fair and Equitable Treatment</li>
                                <li>Right to Adequate Information</li>
                                <li>Right to Initial and Continuing Disclosure - Right to receive information about all the statutory and regulatory disclosures.</li>
                                <li>Right to Fair & True Advertisement</li>
                                <li>Right to Awareness about Service Parameters and Turnaround Times</li>
                                <li>Right to be informed of the timelines for each service</li>
                                <li>Right to be Heard and Satisfactory Grievance Redressal</li>
                                <li>Right to have timely redressal</li>
                                <li>Right to Suitability of the Financial Products</li>
                                <li>Right to Exit from Financial product or service in accordance with the terms of agreement with the investment adviser</li>
                                <li>Right to receive clear guidance and caution notice when dealing in Complex and High-Risk Financial Products and Services</li>
                                <li>Additional Rights to vulnerable consumers - Right to get access to services in a suitable manner even if differently abled</li>
                                <li>Right to provide feedback on the financial products and services used</li>
                                <li>Right against coercive, unfair, and one-sided clauses in financial agreements</li>
                            </ul>
                        </div>
                        {/* Responsibilities of Investors */}
                        <div>
                            <h2 className="text-lg font-semibold mb-6">F. Expectations from the investors (Responsibilities of investors)</h2>

                            <h3 className="font-bold text-md text-white mt-4">Do's</h3>
                            <ul className="list-[upper-roman] list-inside mt-2 text-md space-y-2 text-justify">
                                <li>Always deal with SEBI registered Investment Advisers.</li>
                                <li>Ensure that the Investment Adviser has a valid registration certificate.</li>
                                <li>Check for SEBI registration number.<br />
                                    Please refer to the list of all SEBI registered Investment Advisers which is available on SEBI website in the following link: (<a href="https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doRecognisedFpi=yes&intmId=13" className="text-[#57c0af] underline">Click here</a>).</li>
                                <li>Pay only advisory fees to your Investment Adviser. Make payments of
                                    advisory fees through banking channels only and maintain duly signed
                                    receipts mentioning the details of your payments.</li>
                                <li>Always ask for your risk profiling before accepting investment advice.
                                    Insist that Investment Adviser provides advisory strictly on the basis of
                                    your risk profiling and take into account available investment
                                    alternatives.</li>
                                <li>Ask all relevant questions and clear your doubts with your investment
                                    Adviser before acting on advice.</li>
                                <li>Assess the risk–return profile of the investment as well as the liquidity
                                    and safety aspects before making investments.</li>
                                <li>Insist on getting the terms and conditions in writing duly signed and
                                    stamped. Read these terms and conditions carefully particularly
                                    regarding advisory fees, advisory plans, category of recommendations
                                    etc. before dealing with any Investment Adviser.</li>
                                <li>Be vigilant in your transactions.</li>
                                <li>Approach the appropriate authorities for redressal of your doubts /
                                    grievances.</li>
                                <li>Inform SEBI about Investment Advisers offering assured or guaranteed
                                    returns.</li>
                                <li>Always be aware that you have the right to exit the service of an Investment Adviser</li>
                                <li>Always be aware that you have the right to seek clarifications and clear guidance on advice</li>
                                <li>Always be aware that you have the right to provide feedback to the Investment Adviser in respect of services received.</li>
                                <li>Always be aware that you will not be bound by any clause, prescribed by the investment adviser, which is contravening any regulatory provisions.</li>
                            </ul>

                            <h3 className="font-bold text-md text-white mt-4">Don'ts</h3>
                            <ul className="list-[upper-roman] list-inside mt-2 text-md space-y-2 text-justify">
                                <li>Don’t fall for stock tips offered under the pretext of investment advice.</li>
                                <li>Do not provide funds for investment to the Investment Adviser.</li>
                                <li>Don’t fall for the promise of indicative or exorbitant or assured returns

                                    by the Investment Advisers. Don’t let greed overcome rational

                                    investment decisions.</li>
                                <li>Don’t fall prey to luring advertisements or market rumours.</li>
                                <li>Avoid doing transactions only on the basis of phone calls or messages

                                    from any Investment adviser or its representatives.</li>
                                <li>Don’t take decisions just because of repeated messages and calls by

                                    Investment Advisers.</li>
                                <li>Do not fall prey to limited period discount or other incentive, gifts, etc.

                                    offered by Investment advisers.</li>
                                <li>Do not share login credential and password of your trading and demat accounts with the Investment Adviser</li>
                                <li>Don’t rush into making investments that do not match your risk taking

                                    appetite and investment goals.</li>
                            </ul>
                        </div>
                    </div>
                </section>;
            case "annexureB":
                return <div className="flex flex-col items-center text-white rounded-lg shadow-lg">
                    <h2 className="text-lg font-semibold">
                        No. of Complaints received from Investors
                    </h2>
                    <p className="text-sm">For the month of <span className="font-bold">{complaintData.lastUpdated}</span></p>

                    <div className="mt-4 w-full overflow-hidden">
                        <div className="w-full overflow-hidden border border-[#57c0af]">
                            <div className="w-full overflow-x-auto">
                                <table className="w-full text-sm text-white">
                                    <thead>
                                        <tr className="text-left">
                                            <th className="p-2 border border-[#57c0af]">Received From</th>
                                            <th className="p-2 border border-[#57c0af] hidden sm:table-cell">Pending Last Month</th>
                                            <th className="p-2 border border-[#57c0af]">Received</th>
                                            <th className="p-2 border border-[#57c0af] hidden sm:table-cell">Resolved</th>
                                            <th className="p-2 border border-[#57c0af]">Total Pending</th>
                                            <th className="p-2 border border-[#57c0af] hidden md:table-cell">Pending &gt; 3 Months</th>
                                            <th className="p-2 border border-[#57c0af] hidden md:table-cell">Avg Resolution Time (Days)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[
                                            { source: "Directly from Investors", pending: 0, received: 0, resolved: "NA", totalPending: 0, pending3Months: 0, resolutionTime: 0 },
                                            { source: "SEBI (SCORES)", pending: 0, received: 0, resolved: "NA", totalPending: 0, pending3Months: 0, resolutionTime: 0 },
                                            { source: "Other", pending: 0, received: 0, resolved: "NA", totalPending: 0, pending3Months: 0, resolutionTime: 0 },
                                            { source: "Sources (if any)", pending: 0, received: 0, resolved: "NA", totalPending: 0, pending3Months: 0, resolutionTime: 0 },
                                        ].map((item, index) => (
                                            <tr key={index} className="border-t border-[#57c0af]">
                                                <td className="p-2 border border-[#57c0af]">{item.source}</td>
                                                <td className="p-2 border border-[#57c0af] hidden sm:table-cell text-center">{item.pending}</td>
                                                <td className="p-2 border border-[#57c0af] text-center">{item.received}</td>
                                                <td className="p-2 border border-[#57c0af] hidden sm:table-cell text-center">{item.resolved}</td>
                                                <td className="p-2 border border-[#57c0af] text-center">{item.totalPending}</td>
                                                <td className="p-2 border border-[#57c0af] hidden md:table-cell text-center">{item.pending3Months}</td>
                                                <td className="p-2 border border-[#57c0af] hidden md:table-cell text-center">{item.resolutionTime}</td>
                                            </tr>
                                        ))}
                                        <tr className="font-bold">
                                            <td className="p-2 border border-[#57c0af]">Grand Total</td>
                                            <td className="p-2 border border-[#57c0af] hidden sm:table-cell text-center">0</td>
                                            <td className="p-2 border border-[#57c0af] text-center">0</td>
                                            <td className="p-2 border border-[#57c0af] hidden sm:table-cell text-center">NA</td>
                                            <td className="p-2 border border-[#57c0af] text-center">0</td>
                                            <td className="p-2 border border-[#57c0af] hidden md:table-cell text-center">0</td>
                                            <td className="p-2 border border-[#57c0af] hidden md:table-cell text-center">0</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                    <div className="mt-4 text-md text-gray-400 text-center">
                        <p>* Inclusive of complaints of previous months resolved in the current month.</p>
                        <p># Inclusive of complaints pending as on the last day of the month.</p>
                        <p>
                            ^ Average Resolution time is the sum total of time taken to resolve each complaint in days,
                            in the current month divided by total number of complaints resolved in the current month.
                        </p>
                    </div>
                    <h2 className="text-lg font-semibold mt-12">
                        Trend of monthly disposal of complaints
                    </h2>
                    <div className="mt-4 w-full overflow-x-auto">
                        <table className="w-full border border-[#57c0af] text-sm text-white">
                            <thead>
                                <tr>
                                    <th className="border border-[#57c0af] p-3">Month</th>
                                    <th className="border border-[#57c0af] p-3">Carried forward from previous month</th>
                                    <th className="border border-[#57c0af] p-3">Received</th>
                                    <th className="border border-[#57c0af] p-3">Resolved</th>
                                    <th className="border border-[#57c0af] p-3">Pending</th>
                                </tr>
                            </thead>
                            <tbody>
                                {months.slice().reverse().map((item, index) => (
                                    <tr key={index}>
                                        <td className="border border-[#57c0af] p-3">{item.month}</td>
                                        <td className="border border-[#57c0af] p-3">{item.carriedForward}</td>
                                        <td className="border border-[#57c0af] p-3">{item.received}</td>
                                        <td className="border border-[#57c0af] p-3">{item.resolved}</td>
                                        <td className="border border-[#57c0af] p-3">{item.pending}</td>
                                    </tr>
                                ))}
                                <tr className="font-bold">
                                    <td className="border border-[#57c0af] p-3">Grand Total</td>
                                    <td className="border border-[#57c0af] p-3">0</td>
                                    <td className="border border-[#57c0af] p-3">0</td>
                                    <td className="border border-[#57c0af] p-3">NA</td>
                                    <td className="border border-[#57c0af] p-3">0</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="mt-4 text-md text-gray-400 text-center">
                        <p>
                            * Inclusive of complaints of previous months resolved in the current month. <br />
                            # Inclusive of complaints pending as on the last day of the month
                        </p>
                    </div>

                    <h2 className="text-lg font-semibold mt-12">
                        Trend of annual disposal of complaints
                    </h2>
                    <div className="mt-4 w-full overflow-x-auto">
                        <table className="w-full border border-[#57c0af] text-sm text-white">
                            <thead>
                                <tr>
                                    <th className="border border-[#57c0af] p-3">Year</th>
                                    <th className="border border-[#57c0af] p-3">Carried forward from previous year</th>
                                    <th className="border border-[#57c0af] p-3">Received</th>
                                    <th className="border border-[#57c0af] p-3">Resolved</th>
                                    <th className="border border-[#57c0af] p-3">Pending</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={index}>
                                        <td className="border border-[#57c0af] p-3">{item.year}</td>
                                        <td className="border border-[#57c0af] p-3">{item.carriedForward}</td>
                                        <td className="border border-[#57c0af] p-3">{item.received}</td>
                                        <td className="border border-[#57c0af] p-3">{item.resolved}</td>
                                        <td className="border border-[#57c0af] p-3">{item.pending}</td>
                                    </tr>
                                ))}
                                <tr className="font-bold">
                                    <td className="border border-[#57c0af] p-3">Grand Total</td>
                                    <td className="border border-[#57c0af] p-3">0</td>
                                    <td className="border border-[#57c0af] p-3">0</td>
                                    <td className="border border-[#57c0af] p-3">NA</td>
                                    <td className="border border-[#57c0af] p-3">0</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="mt-4 text-md text-gray-400 text-center">
                        <p>
                            *Inclusive of complaints of previous years resolved in the current year.<br />
                            #Inclusive of complaints pending as on the last day of the year.
                        </p>
                    </div>

                </div>;
        }
    };

    return (
        <section className="py-10 sm:py-16 -mt-16 text-white min-h-screen">
            <div className="flex flex-col lg:flex-row gap-6">
                {/* Left Side Navigation */}
                <div className="lg:w-1/4 w-full p-4 rounded-lg shadow-lg">
                    <ul className="space-y-4">
                        {[
                            { id: "annexureA", label: "Investor Charter Annexure A" },
                            { id: "annexureB", label: "Investor Charter Annexure B" },
                        ].map((item) => (
                            <li key={item.id}>
                                <button
                                    className={`block text-nowrap py-2 px-4 w-full text-left rounded-3xl transition-colors duration-200 ${selectedPage === item.id
                                        ? "bg-[#57c0af] text-black font-semibold"
                                        : "hover:bg-[#57c0af] text-white text-md"
                                        }`}
                                    onClick={() => setSelectedPage(item.id)}
                                >
                                    {item.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                {/* Main Content */}
                <div className="min-h-screen bg-black">
                    {/* <NavigationBar /> */}
                    <div className="min-h-screen text-white bg-black pt-20 p-4 md:p-6 lg:p-8">
                        <div className="max-w-7xl mx-auto">
                            {/* Header Section */}
                            <div className="mb-8">
                                <div className="bg-customBlack rounded-3xl p-6">
                                    <div className="flex justify-between">
                                        <Link to={'/settings'}>
                                            <IoArrowBackCircleSharp size={32} className="text-[#57c0af] " />
                                        </Link>
                                        <h1 className="text-2xl md:text-3xl font-bold text-[#57c0af] mb-4 text-center">
                                            Investor Charter
                                        </h1>
                                        <div></div>
                                    </div>
                                    {renderContent()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InvestorCharter;
